import React, { useState } from "react";
import AppointmentModal from "@/site/components/AppointmentModal";

const Job_positions = [
  // {
  //   title: "Fellowships in Arthroplasty, Orthopedic Trauma & Spine Surgeon",
  //   education: "M.S. Orthopaedics / DNB Orthopaedics",
  //   exp: "-",
  //   location: "S B Road, Nigdi, Chinchwad",
  // },
   {
    title: "Staff Nurse (Nursing-ICU)",
    education: "GNM/BSc Nursing",
    exp: "Minimum 1 Year Experience",
    location: "All Units",
  },
    {
    title: "Staff Nurse (Nursing-Ward)",
    education: "GNM/BSc Nursing",
    exp: "Minimum 1 Year Experience",
    location: "All Units",
  },
     {
    title: "Staff Nurse (Nursing-OT)",
    education: "GNM/BSc Nursing",
    exp: "2+ Years Revelent Experience",
    location: "All Units",
  },
    {
    title: "Asst. Manager (Sales & Buisiness Development)",
    education: "MBA-Marketing",
    exp: "-",
    location: "Nigdi",
  },
    {
    title: "Physiotherapist (Physiotherpy)",
    education: "BPTh/MPTh",
    exp: "3+ Years Experience",
    location: "Nigdi",
  },
    {
    title: "Staff Nurse (Nursing-Cardiac Recovery)",
    education: "GNM/BSc Nursing",
    exp: "2+ Years Revelent Experience CRR",
    location: "Chinchwad",
  },
  {
    title: "Clinical Assistant (Medical Services-Cardiac Recovery)",
    education: "BAMS/BHMS",
    exp: "2+ Years Revelent Experience CRR",
    location: "Chinchwad",
  },
  {
    title: "Staff Nurse (Nursing-Oncology)",
    education: "GNM/BSc Nursing",
    exp: "2+ Years Revelent Experience in Oncology",
    location: "SB Road",
  },
  {
    title: "Clinical Assistant (Medical Services-Ward/ICU)",
    education: "BAMS/BHMS",
    exp: "1+ Years Revelent Experience",
    location: "All Units",
  },
   {
    title: "Technician (Operation Theatre)",
    education: "OT Diploma",
    exp: "2+ Years Revelent Experience",
    location: "Chinchwad",
  },
    {
    title: "Technician (Cathlab)",
    education: "Diploma",
    exp: "2+ Years Revelent Experience",
    location: "Chinchwad",
  },
    {
    title: "Exceautive (Tele Marketing)",
    education: " ",
    exp: "0 To 1 Yrs of Revelent Experience",
    location: "All Units",
  }
];

const AvailablePositions = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState("");

  const handleModalOpen = (title) => {
    setModalTitle(title);
    setIsModalOpen(true);
  };
  const handleModalClose = () => setIsModalOpen(false);

  return (
    <section className="available-positions section-below-space side-space">
      <h2 className="section-heading">Available Positions</h2>
      <div className="table-outer">
        <table className="table positions-table">
          <thead>
            <tr>
              <th scope="col">JOB TITLE</th>
              <th scope="col">YEARS OF EXP</th>
              <th scope="col">EDUCATION</th>
              <th scope="col">LOCATION</th>
              <th scope="col">Apply now</th>
            </tr>
          </thead>
          <tbody>
            {Job_positions.map((position, index) => (
              <tr key={index}>
                <td scope="row">{position.title}</td>
                <td>{position.exp}</td>
                <td>{position.education}</td>
                <td>{position.location}</td>
                <td>
                  <button
                    type="button"
                    className="button-primary mx-auto"
                    onClick={() => handleModalOpen(position.title)}
                  >
                    <span>APPLY</span>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Appointment Modal */}
      <AppointmentModal
        isModalOpen={isModalOpen}
        handleModalClose={handleModalClose}
        file={true}
        title={modalTitle}
      />
    </section>
  );
};

export default AvailablePositions;
